import { Box, Divider, IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material"
import { MoreVertOutlined, SubdirectoryArrowRightOutlined, VisibilityOutlined } from "@mui-symbols-material/w300"
import type { CellContext } from "@tanstack/react-table"
import type { FC } from "react"
import { useRef, useState } from "react"

import { SHOULD_SHOW_UNIMPLEMENTED } from "../../constants"

import type { InventoryByLotItem } from "@/graphql/codegen/graphql"

interface ProductInventoryLotRowActionsProps {
  row: CellContext<InventoryByLotItem, unknown>["row"]
  canMaintain: boolean
  onTransfer?: (item: InventoryByLotItem) => void
  onCoaView?: (item: InventoryByLotItem) => void
}

export const ProductInventoryLotRowActions: FC<ProductInventoryLotRowActionsProps> = ({
  row,
  canMaintain,
  onTransfer,
  onCoaView,
}) => {
  const anchorElRef = useRef<HTMLButtonElement>(null)
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const handleClick = (e: React.MouseEvent) => e.stopPropagation()

  const handleMenuOpen = () => setIsMenuOpen(true)

  const handleMenuClose = () => setIsMenuOpen(false)

  const handleTransfer = () => {
    handleMenuClose()
    onTransfer?.(row.original)
  }

  const handleCoaView = () => {
    handleMenuClose()
    onCoaView?.(row.original)
  }

  return (
    <Box className='flex items-center justify-end' ref={anchorElRef} onClick={handleClick}>
      <IconButton onClick={handleMenuOpen} data-testid='product-inventory-lot.row-actions.actions-button'>
        <MoreVertOutlined />
      </IconButton>
      <Menu
        anchorEl={anchorElRef.current}
        open={isMenuOpen}
        onClose={handleMenuClose}
        data-testid='product-inventory-lot.row-actions.actions-menu'
      >
        {SHOULD_SHOW_UNIMPLEMENTED && canMaintain && (
          <>
            <MenuItem onClick={handleTransfer} data-testid='product-inventory-lot.row-actions.transfer-inventory-item'>
              <ListItemIcon>
                <SubdirectoryArrowRightOutlined />
              </ListItemIcon>
              <ListItemText primary='Transfer Inventory' />
            </MenuItem>
            <Divider />
          </>
        )}
        <MenuItem onClick={handleCoaView} data-testid='product-inventory-lot.row-actions.view-coa-item'>
          <ListItemIcon>
            <VisibilityOutlined />
          </ListItemIcon>
          <ListItemText primary='View COA' />
        </MenuItem>
      </Menu>
    </Box>
  )
}
